<template>
  <ServiceFormWrapper :config="config" v-bind="$attrs">
    <template #edit-form="{ props, listeners }">
      <ServiceForm :schema="config.schema" v-bind="props" v-on="listeners" />
    </template>

    <template #form="{ props, listeners }">
      <ServiceForm :schema="config.schema" v-bind="props" v-on="listeners" />
    </template>
  </ServiceFormWrapper>
</template>

<script>
import ServiceFormWrapper from './ServiceFormWrapper';
import ServiceForm from './ServiceForm';
import SupplementaryServiceFormCatalogMixin from '../_mixins/SupplementaryServiceFormCatalog.mixin';
import { supplementaryServicesConfig } from '../_config';

export default {
  name: 'SupplementaryServiceFormWrapper',
  components: {
    ServiceFormWrapper,
    ServiceForm: {
      ...ServiceForm,
      ...{
        mixins: [
          ...(ServiceForm.mixins || []),
          SupplementaryServiceFormCatalogMixin,
        ],
      },
    },
  },
  data: () => ({
    config: supplementaryServicesConfig,
  }),
};
</script>
